const theme = {
  gap: "20px",
  padding: "5px",
  red: "tomato",
  blue: "cornflowerblue",
  yellow: "gold",
  semiRed: "rgba(255, 150, 131, 0.6)",
  semiBlue: "rgba(150, 187, 255, 0.6)",
  semiYellow: "rgba(255, 236, 131, 0.4)",
  lightBeige: " rgb(218, 192, 160)",
  darkBeige: "rgb(182, 160, 134)",
};

export default theme;
